import { render, staticRenderFns } from "./BusinessTeams.vue?vue&type=template&id=173c005b&scoped=true"
import script from "./BusinessTeams.vue?vue&type=script&lang=js"
export * from "./BusinessTeams.vue?vue&type=script&lang=js"
import style0 from "./BusinessTeams.vue?vue&type=style&index=0&id=173c005b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173c005b",
  null
  
)

export default component.exports